export enum CONFIG_ITEMS {
  CROSS = 'CROSS',
  ISOLATED = 'ISOLATED',
}
